






































































































































import Vue from 'vue'
import { Location as FirestoreLocation } from '@/models'
import { Location } from '@/models/api'

const DEPLOYMENT_BASE_URL = 'https://widgets.leadconnectorhq.com/'
const TEXT_WIDGET_DEPLOYMENT = `${DEPLOYMENT_BASE_URL}loader.js`
const TEXT_WIDGET_IE_DEPLOYMENT = `${DEPLOYMENT_BASE_URL}chat-widget/loader.js`
const DEFAULT_LEGAL_MESSAGE =
  'By submitting you agree to receive SMS or e-mails for the provided channel. Rates may be applied.'
const DEFAULT_REVISIT_MSG = 'Welcome back {{name}}, How can we help you today?'
const DEFAULT_HEADING = 'Have a question?'
const DEFAULT_SUB_HEADING =
  'Enter your question below and a representative will get right back to you.'
const DEFAULT_SUCCESS_MESSAGE =
  'One of our representatives will contact you shortly.'
const DEFAULT_THANKS_MESSAGE = 'Thank You!'
const DEFAULT_PROMPT_MESSAGE = 'Hi there, have a question? Text us here.'
import CelebrationIcon from '@/assets/pmd/img/celebration.svg'
export default Vue.extend({
  components:{CelebrationIcon},
  props: [
    'cms',
    'instruction',
    'currentStep',
    'screenshot',
    'chatIntegrated',
    'widgetSettings',
  ],
  data() {
    return {
      showCopiedCodeToolTip: false,
      loaderScriptURL: TEXT_WIDGET_DEPLOYMENT,
      IELoaderScriptURL: TEXT_WIDGET_IE_DEPLOYMENT,
      widgetPrimaryColor: '#188bf6',
      steps: [] as any,
      locationId: '',
      location: {} as Location,
    }
  },
  async mounted() {
    this.locationId = this.$router.currentRoute.params.location_id
    this.location = new FirestoreLocation(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.locationId
      )
    )
    if (this.cms) this.steps = this.instruction.steps
  },
  watch: {
    cms: async function () {
      this.steps = this.instruction.steps
    },
  },
  methods: {
    async copyToClipboard() {
      try {
        this.showCopiedCodeToolTip = true
        if (this.steps[this.currentStep].widgetCode) {
          this.clipboardCopy(this.getScriptCode())
        } else if (this.steps[this.currentStep].apiKey) {
          const res = await Location.getKeyByLocationId(this.locationId)
          this.clipboardCopy(res?.apiKey)
        }
        setTimeout(() => this.showCopiedCodeToolTip = false, 2000);
      } catch (err) {
        setTimeout(() => this.showCopiedCodeToolTip = false, 2000);
        console.error(err)
      }
    },
    getImgUrl(pic: string) {
      const images = require.context(
        '../../../assets/pmd/img/launchpad/',
        false,
        /(\.png|\.svg)$/
      )
      return images('./' + pic)
    },
    getScriptCode() {
      const elementName = 'chat-widget'
      const script = 'script'
      const attrPrefix = ''
      const revisitMessage = this.widgetSettings.revisitPromptMsg
      const importScriptCode = `<${script} src="${this.loaderScriptURL}"
          data-resources-url="${this.IELoaderScriptURL}" ></${script}>`

      let scriptCode = `    <${elementName}
            data-chat-widget
            ${attrPrefix}style="--chat-widget-primary-color: ${
        this.widgetPrimaryColor
      }; --chat-widget-active-color:${
        this.widgetPrimaryColor
      } ;--chat-widget-bubble-color: ${this.widgetPrimaryColor}"
            ${attrPrefix}location-id="${this.locationId}"
            ${attrPrefix}heading="${this.widgetSettings.heading}"
            ${attrPrefix}sub-heading="${this.widgetSettings.subHeading}"
            ${attrPrefix}prompt-msg="${this.widgetSettings.promptMsg}"
            ${attrPrefix}legal-msg="${this.widgetSettings.legalMsg}"
            ${attrPrefix}show-prompt="${this.widgetSettings.showPrompt}"
            ${attrPrefix}use-email-field="${this.widgetSettings.useEmailField}"
            ${attrPrefix}enable-revisit-message="${
        this.widgetSettings.enableRevisitMessage
      }"
            ${attrPrefix}revisit-prompt-msg="${revisitMessage}"
            ${attrPrefix}support-contact="${this.widgetSettings.supportContact}"
            ${attrPrefix}success-msg="${this.widgetSettings.successMsg}"
            ${attrPrefix}thank-you-msg="${this.widgetSettings.thankYouMsg}"
            ${attrPrefix}prompt-avatar="${this.widgetSettings.promptAvatar}"
            ${attrPrefix}auto-country-code="${
        this.widgetSettings.autoCountryCode
      }"
            ${attrPrefix}country-code="${
        this.widgetSettings.countryCode ? this.widgetSettings.countryCode : 'US'
      }"
      ></${elementName}>
       ${importScriptCode}`

      let startIndex = scriptCode.indexOf('data-chat-widget')
      let endIndex = scriptCode.indexOf('\n', startIndex)
      scriptCode = scriptCode.replace(
        scriptCode.substring(startIndex, endIndex + 13),
        ''
      )
      if (
        DEFAULT_PROMPT_MESSAGE === this.widgetSettings.promptMsg ||
        !this.widgetSettings.showPrompt
      ) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}prompt-msg="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (DEFAULT_HEADING === this.widgetSettings.heading) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}heading="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }

      if (DEFAULT_SUB_HEADING === this.widgetSettings.subHeading) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}sub-heading="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        this.widgetSettings.enableRevisitMessage ||
        !this.widgetSettings.showPrompt
      ) {
        let startIndex = scriptCode.indexOf(
          `${attrPrefix}enable-revisit-message="`
        )
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
        if (
          DEFAULT_REVISIT_MSG === this.widgetSettings.revisitPromptMsg ||
          !this.widgetSettings.showPrompt
        ) {
          startIndex = scriptCode.indexOf(`${attrPrefix}revisit-prompt-msg="`)
          endIndex = scriptCode.indexOf('\n', startIndex)
          scriptCode = scriptCode.replace(
            scriptCode.substring(startIndex, endIndex + 13),
            ''
          )
        }
      } else {
        const startIndex = scriptCode.indexOf(
          `${attrPrefix}revisit-prompt-msg="`
        )
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }

      if (this.widgetSettings.legalMsg === DEFAULT_LEGAL_MESSAGE) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}legal-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }

      if (this.widgetSettings.showPrompt) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}show-prompt="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (!this.widgetSettings.useEmailField) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}use-email-field="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (!this.widgetSettings.supportContact) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}support-contact="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        !this.widgetSettings.successMsg ||
        DEFAULT_SUCCESS_MESSAGE === this.widgetSettings.successMsg
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}success-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }

      if (
        !this.widgetSettings.thankYouMsg ||
        DEFAULT_THANKS_MESSAGE === this.widgetSettings.thankYouMsg
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}thank-you-msg="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (
        !this.widgetSettings.promptAvatar ||
        !this.widgetSettings.showPrompt
      ) {
        const startIndex = scriptCode.indexOf(`${attrPrefix}prompt-avatar="`)
        const endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
      }
      if (this.widgetSettings.autoCountryCode) {
        let startIndex = scriptCode.indexOf(`${attrPrefix}auto-country-code="`)
        let endIndex = scriptCode.indexOf('\n', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 13),
          ''
        )
        startIndex = scriptCode.indexOf(`${attrPrefix}country-code="`)
        endIndex = scriptCode.indexOf('"', startIndex)
        scriptCode = scriptCode.replace(
          scriptCode.substring(startIndex, endIndex + 4),
          ''
        )
      }
      return scriptCode
    },
  },
  computed: {
    apiKey() {
      let key = this.location.apiKey || '*'.repeat(16);
      if (!key || key.length < 1) return
      return `${key.slice(0, 4)}****-****-****-****-******${key.slice(-6)}`
    },
  }
})
